<template>
<div>
  <div class="bg-primary-lightest py-10">
    <div class="static-container text-center sm:text-left">
      <h2 class="text-3xl sm:text-6xl font-bold">
        {{ title }}
      </h2>
    </div>
  </div>
  <div class="static-container mt-10">
    <div class="legal-document-content prose mb-4 max-w-full px-4 sm:px-0" v-html="documentContent"></div>
  </div>
</div>
</template>

<script>
import axios from '@/zenky'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },
  },

  created() {
    this.loadLegalDocument();
  },

  methods: {
    loadLegalDocument() {
      if (this.loading) {
        return
      }

      this.loading = true;

      axios.get(`legal/documents/${this.type}`)
        .then(({ data }) => {
          this.documentContent = data.data.content;
        })
        .catch(err => {
          console.error(err);
        })
    },
  },

  data() {
    return {
      documentContent: '',
      loading: false,
    };
  },
}
</script>

<style lang="less">
.legal-document-content {
  h1, h2, h3, h4, h5, h6 {
    word-break: break-all;
  }
}
</style>
